'use strict';

import { debounce, displayErrors, delay, adjustFooterOnWindowResize } from '../../_assets/abbott/js/_helper';
import { toaster } from '../../_assets/abbott/js/_material';

export default class GlobalSearch {
    constructor() {
        let that = this,
            $body = $('body'),
            $globalSearch = $('#global-search'),
            $globalSearchDropdown = $('.global-search__dropdown'),
            $globalSearchPagination = $('.global-search__pagination ul'),
            $globalSearchSuggestion = $('.global-search__suggestions ul'),
            $results = $('.global-search__results-wrap'),
            dataParams = {},
            $globalSearchVal;

        if (!$globalSearch.length) {
            return false;
        }

        $('.js-expand-search').on('click', function (e) {
            e.preventDefault();


            $globalSearchDropdown.slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false,
                complete: function () {
                    $body.addClass('fixed');
                }
            });

            $globalSearch.focus();
        });

        $('.js-collapse-search').on('click', function (e) {
            e.preventDefault();

            $body.removeClass('fixed');

            $globalSearchDropdown.slideUp({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
        });

        $('.js-clear-field').on('click', function (e) {
            e.preventDefault();

            $globalSearch.val('').focus();
            $globalSearchSuggestion.html('');
            $globalSearchDropdown.removeClass('compact');
            $results.fadeOut({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });;
        });

        $body.on('click', '.global-search__dropdown .js-select-item', function (e) {
            e.preventDefault();

            $globalSearch.val('');
            window.location.href = $(this).data('link');
        });

        $body.on('click', '.global-search__dropdown .js-search-page', function (e){

            // Define where to display ajax errors
            let $errorContainer = $('global-search__form').find('.server-errors__wrap');

            $globalSearchVal = $globalSearch.val().trim();

            dataParams = {
                'term': $globalSearchVal,
                'skip': $(this).data('page') - 1
            };
            var encodedParams = jQuery.param(dataParams);
            $.ajax({
                url: '/api/search?'+encodedParams,
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                type: 'GET',
                success: function (data) {
                    if ($globalSearchVal == '') {
                        return false;
                    }

                    that.listResults(data, $errorContainer);


                },
                error: function (error) {
                    displayErrors(error, $errorContainer );
                    adjustFooterOnWindowResize();
                }
            }).done(function () {
                adjustFooterOnWindowResize();
            });
        });

        $globalSearch.on('keyup', function (e) {
            // Define where to display ajax errors
            let $errorContainer = $(this).parent().siblings('.server-errors__wrap');

            $globalSearchVal = $globalSearch.val().trim();

            // call different api if enter is pressed
            if (e.keyCode == 13) {
                that.doProperSearch();

                return false;
            }

            dataParams = {
                'term': $globalSearchVal,
                'skip': 0
            };
            var encodedParams = jQuery.param(dataParams);

            delay( "date-check", function(){$.ajax({
                url: '/api/search?'+encodedParams,
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                type: 'GET',
                success: function (data) {
                    if ($globalSearchVal == '') {
                        return false;
                    }

                    that.listResults(data, $errorContainer);
                },
                error: function (error) {
                    displayErrors(error, $errorContainer );
                }
            });} , 600);

        });
    }

    listResults(data, $errorContainer ){

        let $globalSearchPagination = $('.global-search__pagination ul'),
            $globalSearchSuggestion = $('.global-search__suggestions ul'),
            $results = $('.global-search__results-wrap'),
            dropdownHeight = $(window).height(),
            resultsHeight = dropdownHeight - 325, // need to make it dynamic
            recordsTotal = data.Total,
            length = data.Take,
            obj = {},
            numberOfPage,
            searchSuggestionHtml = '',
            searchSuggestionTmp = '',
            searchPaginationHtml = '',
            searchPaginationTmp = '';

        // Define templates
        searchSuggestionTmp = doT.template($('#global-search-suggestion-tmp').html());
        searchPaginationTmp = doT.template($('#global-search-pagination-tmp').html());

        $errorContainer.slideUp({
            duration: 500,
            easing: 'easeInOutExpo',
            queue: false
        });

        if (!data.Items.length){

            $results.fadeOut({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            $errorContainer.html('<p> No results found. </p>');

            $errorContainer.slideDown({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

            return false;
        }

        //Display pagination
        if(recordsTotal > length){
            numberOfPage = parseInt(recordsTotal / length);

            if ( parseInt(recordsTotal % length) > 0) {
                numberOfPage ++;
            }
        }

        for (let i = 1, l = numberOfPage; i <= l; i++) {
            obj = {
                'page': i
            };

            searchPaginationHtml += searchPaginationTmp(obj)
        }

        $globalSearchPagination.html(searchPaginationHtml);


        //Display results
        for (let i = 0, l = data.Items.length; i < l; i++) {
            obj = {
                'icon': data.Items[i].Icon,
                'title': data.Items[i].Title,
                'details': data.Items[i].Details,
                'link': data.Items[i].Link
            };

            searchSuggestionHtml += searchSuggestionTmp(obj)
        }

        $globalSearchSuggestion.html(searchSuggestionHtml);

        $globalSearchPagination.find("[data-page='"+ (data.Skip + 1) + "']").parent().addClass('active');

        $results.css('min-height', resultsHeight);

        $results.fadeIn({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

    }

    doProperSearch () {
        let that = this,
            $body = $('body'),
            $globalSearch = $('#global-search'),
            $globalSearchVal = $globalSearch.val().trim(),
            $globalSearchDropdown = $('.global-search__dropdown'),
            $globalSearchLabel = $('.global-search__label'),
            $globalSearchSuggestion = $('.global-search__suggestions ul'),
            $globalSearchPagination = $('.global-search__pagination ul'),
            dataParams = {};

        // Define where to display ajax errors
        let $errorContainer = $(this).parent().siblings('.server-errors__wrap');

        $globalSearchDropdown.addClass('compact');
        $globalSearchLabel.text('Showing all results for');

        dataParams = {
            'term': $globalSearchVal,
            'skip': 0
        };
        var encodedParams = jQuery.param(dataParams);
        $.ajax({
            url: '/api/search?' + encodedParams,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            type: 'GET',
            success: function (data) {
                if ($globalSearchVal == '') {
                    return false;
                }

                that.listResults(data, $errorContainer );
            },
            error: function (error) {
                displayErrors(error, $errorContainer );
            }
        });
    }
}
